module.exports = new __parcel__URL__("vulcan-co2-yeargrid-v4.thumbnails.total.a0dc197e.png").toString();